import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-notre-approche',
  standalone: true,
  imports: [CommonModule, PageLayoutComponent],
  templateUrl: './notre-approche.component.html',
  styleUrls: ['./notre-approche.component.css']
})
export class NotreApprocheComponent implements OnInit {
  title = 'Notre Approche';
  subtitle = '';
  heroImage = 'assets/static_pages_images/notre-approche.jpg';
  
  breadcrumbs = [
    { label: 'Notre Approche', link: undefined }
  ];

  prevPage = {
    title: 'Notre Équipe',
    link: '/notre-equipe'
  };

  nextPage = {
    title: 'Avis Clients',
    link: '/landing'
  };

  // État du contenu détaillé
  showDetailedContent: boolean = false;

  constructor(private router: Router) {}

  ngOnInit(): void {}

  toggleDetailedContent(): void {
    this.showDetailedContent = !this.showDetailedContent;
  }

  navigateToComparison(): void {
    this.router.navigate(['/cac/comparaison']);
  }
}
  
